// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"bfcf02f5","201":"bfcf02f5","455":"e929083e","497":"e929083e","620":"e929083e","789":"05dff57d"}[chunkId] + ".chunk.css";
};